import React from 'react';
import { Image, Pressable, Text, View } from 'react-native';
import { useAnalytics } from 'services/analytics/useAnalytics';

import BandHeaderLogo from 'assets/Header/logoHeader.png';

import { BaseModal, ModalProps } from 'components/Modal';

type ModalConfirmExitKidsProps = Partial<ModalProps> & {
  toggleModal: () => void;
  handleKidLogout: () => void;
};

const ModalConfirmExitKids: React.FC<ModalConfirmExitKidsProps> = ({
  toggleModal,
  handleKidLogout,
  ...rest
}) => {
  const analytics = useAnalytics();

  const loginAgain = () => {
    analytics.triggerLoginAgainActionEvent();
    handleKidLogout();
  };

  const keepInKidsMode = () => {
    analytics.triggerKeepKidsModeActionEvent();
    toggleModal();
  };

  return (
    <BaseModal
      {...rest}
      size="sm"
      onClose={toggleModal}
      modalHeader={
        <Image
          source={BandHeaderLogo}
          style={{
            width: 100,
            height: 22,
            resizeMode: 'cover',
          }}
        />
      }
      modalBody={
        <View>
          <View>
            <Text
              style={{
                color: '#FFFFFF',
                fontFamily: 'system-ui',
                fontSize: 18,
                fontWeight: '700',
                marginBottom: 15,
              }}>
              Ao sair do Modo Infantil toda a programação sem filtro de classificação indicativa
              voltará a ser exibida.
            </Text>
            <Text
              style={{
                color: '#FFFFFF',
                fontFamily: 'system-ui',
                fontSize: 18,
                marginTop: 6,
              }}>
              Para garantir a segurança de acesso, será necessário logar novamente.
            </Text>
          </View>
        </View>
      }
      modalFooter={
        <View
          style={{
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            marginVertical: 10,
            gap: 12,
          }}>
          <Pressable
            onPress={loginAgain}
            style={{
              width: '100%',
              height: 40,
              flexDirection: 'row',
              backgroundColor: '#2543BE',
              paddingHorizontal: 20,
              borderRadius: 4,
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            <Text
              style={{
                color: '#FFFFFF',
                fontFamily: 'system-ui',
                fontSize: 14,
                fontWeight: '700',
                lineHeight: 22,
                textTransform: 'capitalize',
              }}>
              Fazer login novamente
            </Text>
          </Pressable>

          <Pressable
            onPress={keepInKidsMode}
            style={{
              width: '100%',
              height: 40,
              flexDirection: 'row',
              paddingHorizontal: 20,
              borderRadius: 4,
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'transparent',
            }}>
            <Text
              style={{
                color: '#839CFF',
                fontFamily: 'system-ui',
                fontSize: 14,
                fontWeight: '700',
                lineHeight: 22,
                textTransform: 'capitalize',
              }}>
              Continuar no Modo Infantil
            </Text>
          </Pressable>
        </View>
      }
    />
  );
};

export default ModalConfirmExitKids;
